<template>
  <ChartLayout :title="title" :half="half">
    <DataGetter :url="apiRoute" :params="params" v-slot="{ data }">
      <DataSlicer
        :data="data"
        x-axis-dimension="country"
        y-axis-dimension="techSector"
        value-dimension="value"
        no-single-value
        class="exit-chart"
        v-slot="{ slicedData }"
      >
        <footer class="m-chart__footer">
          <ChartLegend
            :legend-items="[
              { name: low, colorIndex: 5 },
              { name: high, colorIndex: 1 },
            ]"
          />
        </footer>
        <Chart
          :options="{
            ...chartOptions,
            series: formatSeries(slicedData),
          }"
        />
      </DataSlicer>
    </DataGetter>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
  ChartLegend,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    exitType: {
      type: String,
      default: "IPO",
    },
    grouping: {
      type: String,
      required: true,
    },
    half: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Chart,
    ChartLayout,
    ChartLegend,
    DataGetter,
    DataSlicer,
  },
  data() {
    return {
      opposites: {
        Energy: "Non-energy",
        "Energy and digital": "Energy and non-digital",
        "Clean energy": "Non-clean energy",
      },
    };
  },
  computed: {
    chartOptions() {
      const { low, high } = this;
      return ChartOptions.buildOptions(
        {
          chart: {
            inverted: true,
            height: 1200,
          },
          xAxis: {
            type: "category",
          },
          yAxis: {
            opposite: true,
            title: {
              text: "Average years to exit",
            },
            className: "highcharts-show-grid",
          },
          tooltip: {
            formatter: function () {
              return `<span class="highcharts-header">${this.point.name}, ${
                this.point.series.name
              }</span><br>
              <span class="highcharts-color-5">●</span> ${low}: <b>${this.point.low.toFixed(
                1
              )} years</b><br>
              <span class="highcharts-color-1">●</span> ${high}: <b>${this.point.high.toFixed(
                1
              )} years</b>;`;
            },
          },
          plotOptions: {
            dumbbell: {
              marker: {
                enabled: true,
              },
              lineWidth: 4,
            },
          },
        },
        "dumbbell"
      );
    },
    low() {
      return this.grouping;
    },
    high() {
      return this.opposites[this.grouping];
    },
    params() {
      const { grouping, opposites, exitType } = this;
      return {
        year: 2022,
        indicator: ["Success of start-ups"],
        category: exitType,
        techSector: [grouping, opposites[grouping]],
      };
    },
  },
  methods: {
    formatSeries(seriesData) {
      const groupingSeries = seriesData.find(
        (series) => series.name === this.low
      );
      const oppositeSeries = seriesData.find(
        (series) => series.name === this.high
      );
      const data = groupingSeries.data
        .filter(
          (point) =>
            point[0] &&
            point[1] &&
            oppositeSeries.data.findIndex((p) => p[0] === point[0] && p[1]) > -1
        )
        .map((point) => {
          const low = point[1];
          const high = oppositeSeries.data.find((p) => p[0] === point[0])[1];
          return {
            name: point[0],
            low,
            high,
          };
        });
      // .sort((a,b) => (a.low < a.high ? a.low : a.high) - (b.low < b.high ? b.low : b.high));
      // Split into two series to get around class bug with lollipop-stem
      return [
        {
          name: `Average time to ${this.exitType}`,
          showInLegend: false,
          colorIndex: 1,
          data: data.filter((point) => point.low <= point.high),
        },
        {
          name: `Average time to ${this.exitType}`,
          showInLegend: false,
          colorIndex: 5,
          data: data.filter((point) => point.low > point.high),
        },
      ];
    },
  },
};
</script>

<style>
.exit-chart .highcharts-lollipop-low {
  fill: #ffb743 !important;
}
.exit-chart .highcharts-lollipop-high {
  fill: #3e7ad3 !important;
}
</style>
